import { useMobile as useDeviceMobile } from './useDeviceDetection';

/**
 * Hook para detectar si el dispositivo es móvil
 * Compatible con la versión anterior pero usando la nueva detección de dispositivo
 */
export const useMobile = (): boolean => {
  return useDeviceMobile();
};
